import React from 'react'
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";
import { Form, Field } from 'react-final-form'

export default function UiTopDatePicker(props) {
    const { label, name, handleChange, value  } = props;

    return (
        <>
            <label className='sba-telerik-label'>{label}</label>
            <DatePicker
                name={name}
                onChange={(e) => { handleChange(e) }}
                value={value}
            />

        </>


    )
}
